(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mrh-aviso"] && !Shopify.designMode) return;
  try {
    
(function () {
  var DIA = 864e5;
  var fuenteLista = null;

  // «2026-10-31 23:59» → milisegundos, hora del centro de México (UTC−6, sin horario de verano).
  function fecha(txt) {
    var m = String(txt || '').trim().match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2}))?$/);
    if (!m) return null;
    var dos = function (n) { return ('0' + n).slice(-2); };
    var t = Date.parse(m[1] + '-' + dos(m[2]) + '-' + dos(m[3]) + 'T' + dos(m[4] || '0') + ':' + (m[5] || '00') + ':00-06:00');
    return isNaN(t) ? null : t;
  }

  // Cuándo lo cerró: localStorage y, si el navegador no deja, una cookie.
  function galleta(clave) { return clave.replace(/[^\w-]/g, '_'); }
  function leer(clave) {
    try { var v = localStorage.getItem(clave); if (v) return +v || 0; } catch (e) {}
    var m = document.cookie.match(new RegExp('(?:^|; )' + galleta(clave) + '=(\\d+)'));
    return m ? +m[1] : 0;
  }
  function guardar(clave, dias) {
    var t = String(Date.now());
    try { localStorage.setItem(clave, t); } catch (e) {}
    document.cookie = galleta(clave) + '=' + t + '; path=/; max-age=' + Math.round(dias * 86400) + '; SameSite=Lax';
  }

  // Quien llega de un email ya vio los precios: no se le enseña en toda la visita.
  function vieneDeEmail() {
    var q = location.search.toLowerCase();
    var ahora = /[?&]utm_medium=e-?mail(&|$)/.test(q) || /[?&]aviso=no(&|$)/.test(q);
    try {
      if (ahora) sessionStorage.setItem('mrh-aviso-email', '1');
      return ahora || sessionStorage.getItem('mrh-aviso-email') === '1';
    } catch (e) { return ahora; }
  }

  // La Archivo condensada se pide una sola vez y solo cuando el aviso va a salir.
  function pideFuente(url) {
    if (fuenteLista) return fuenteLista;
    fuenteLista = new Promise(function (listo) {
      if (!url || document.querySelector('link[data-mrh-aviso-fuente]')) return listo();
      var l = document.createElement('link');
      l.rel = 'stylesheet'; l.href = url; l.setAttribute('data-mrh-aviso-fuente', '');
      l.onload = l.onerror = function () { listo(); };
      document.head.appendChild(l);
    }).then(function () {
      if (document.fonts && document.fonts.load) return document.fonts.load('900 extra-condensed 60px Archivo').catch(function () {});
    });
    return fuenteLista;
  }
  function imagenes(dlg) {
    return Promise.all(Array.prototype.map.call(dlg.querySelectorAll('img'), function (img) {
      return img.decode ? img.decode().catch(function () {}) : null;
    }));
  }

  function abrir(dlg) {
    if (!dlg || dlg.open || typeof dlg.showModal !== 'function') return;
    dlg.showModal();
    document.documentElement.classList.add('mrh-av-abierto');
  }
  // Cerrar guarda y suelta el scroll en el mismo toque. El evento «close» del
  // diálogo llega después (y en una pestaña oculta puede no llegar): queda de
  // respaldo para cualquier otra vía de cierre.
  function conectar(dlg, alCerrar) {
    var guardado = false;
    function termina() {
      document.documentElement.classList.remove('mrh-av-abierto');
      if (alCerrar && !guardado) { guardado = true; alCerrar(); }
    }
    function cerrar() { if (dlg.open) dlg.close(); termina(); }
    dlg.querySelectorAll('[data-mrh-aviso-cerrar]').forEach(function (b) { b.addEventListener('click', cerrar); });
    // En escritorio el panel va al centro: tocar fuera lo cierra.
    dlg.addEventListener('click', function (e) { if (e.target === dlg) cerrar(); });
    dlg.addEventListener('cancel', termina);   // Escape
    dlg.addEventListener('close', termina);
    dlg._mrhCerrar = cerrar;
  }

  function iniciar(raiz) {
    if (!raiz || raiz.hasAttribute('data-mrh-listo')) return;
    raiz.setAttribute('data-mrh-listo', '');
    var d = raiz.dataset;

    // Editor de temas: sin fechas ni frecuencia; lo abren los eventos de abajo.
    if (d.modo === 'editor') {
      var dlgE = raiz.querySelector('dialog');
      if (!dlgE) return;
      pideFuente(d.fuente);
      conectar(dlgE, null);
      raiz._mrhAbrir = function () { abrir(dlgE); };
      raiz._mrhCerrar = function () { dlgE._mrhCerrar(); };
      return;
    }

    var ahora = Date.now();
    var ini = fecha(d.inicio), fin = fecha(d.fin);
    if ((ini && ahora < ini) || (fin && ahora > fin)) return;
    if (d.email === 'si' && vieneDeEmail()) return;
    var clave = 'mrh-aviso:' + (d.campana || 'aviso');
    var dias = parseFloat(d.dias) || 3;
    var ultimo = leer(clave);
    if (ultimo && ahora - ultimo < dias * DIA) return;

    function mostrar() {
      var tpl = raiz.querySelector('template[data-mrh-aviso-tpl]');
      if (!tpl || !('content' in tpl)) return;
      raiz.appendChild(tpl.content.cloneNode(true));
      var dlg = raiz.querySelector('dialog');
      if (!dlg || typeof dlg.showModal !== 'function') return;
      conectar(dlg, function () { guardar(clave, dias); });
      dlg.querySelectorAll('[data-mrh-aviso-ir]').forEach(function (a) {
        a.addEventListener('click', function () { guardar(clave, dias); });
      });
      var tope = new Promise(function (r) { setTimeout(r, 1800); });
      Promise.race([Promise.all([pideFuente(d.fuente), imagenes(dlg)]), tope]).then(function () { abrir(dlg); });
    }
    function arranca() { setTimeout(mostrar, Math.max(0, (parseFloat(d.retraso) || 0) * 1000)); }
    if (document.readyState === 'complete') arranca();
    else window.addEventListener('load', arranca, { once: true });
  }

  document.querySelectorAll('[data-mrh-aviso]').forEach(iniciar);

  // En el editor: sale al seleccionar la sección o un bloque, y se reabre con cada cambio.
  function raizDe(el) {
    var sec = el && el.closest ? el.closest('.shopify-section') : null;
    return sec ? sec.querySelector('[data-mrh-aviso]') : null;
  }
  document.addEventListener('shopify:section:load', function (e) {
    var r = raizDe(e.target); if (!r) return;
    iniciar(r); if (r._mrhAbrir) r._mrhAbrir();
  });
  document.addEventListener('shopify:section:unload', function () {
    document.documentElement.classList.remove('mrh-av-abierto');
  });
  document.addEventListener('shopify:section:select', function (e) {
    var r = raizDe(e.target); if (r && r._mrhAbrir) r._mrhAbrir();
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var r = raizDe(e.target); if (r && r._mrhCerrar) r._mrhCerrar();
  });
  document.addEventListener('shopify:block:select', function (e) {
    var r = raizDe(e.target); if (r && r._mrhAbrir) r._mrhAbrir();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mrh-baterias"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-mrh-bat]').forEach(function (raiz) {
    var fila = raiz.querySelector('[data-mrh-bat-fila]');
    var puntos = raiz.querySelectorAll('[data-mrh-bat-puntos] i');
    var aviso = raiz.querySelector('[data-mrh-bat-aviso]');

    // ---- los puntos siguen al deslizamiento ----
    function pintarPuntos() {
      if (!fila || !puntos.length) return;
      var tarjetas = fila.children, i = 0, mejor = Infinity;
      var izq = fila.getBoundingClientRect().left;
      for (var k = 0; k < tarjetas.length; k++) {
        var d = Math.abs(tarjetas[k].getBoundingClientRect().left - izq);
        if (d < mejor) { mejor = d; i = k; }
      }
      // Al final de la fila se ilumina el último aunque no llegue al borde.
      if (fila.scrollLeft + fila.clientWidth >= fila.scrollWidth - 4) i = tarjetas.length - 1;
      puntos.forEach(function (p, k) { if (k === i) p.setAttribute('data-activo', ''); else p.removeAttribute('data-activo'); });
    }
    if (fila) fila.addEventListener('scroll', pintarPuntos, { passive: true });

    // ---- carrito de Horizon 3.5: mismo aviso que QUÉ HAY HOY ----
    var eventos = null;
    try { import('@shopify/events').then(function (m) { eventos = m; }, function () {}); } catch (e) {}
    function seccionesCarrito() {
      var ids = [];
      document.querySelectorAll('cart-items-component').forEach(function (c) { if (c.dataset.sectionId) ids.push(c.dataset.sectionId); });
      return ids.join(',');
    }
    function avisar(items, promesa) {
      var datos = { action: 'add', context: 'product', promise: promesa, lines: items.map(function (i) { return { merchandiseId: i.id, quantity: i.quantity }; }) };
      var ev;
      if (eventos && eventos.CartLinesUpdateEvent) ev = new eventos.CartLinesUpdateEvent(datos);
      else { ev = new Event('shopify:cart:lines-update', { bubbles: true, cancelable: true }); Object.assign(ev, datos); }
      raiz.dispatchEvent(ev);
    }
    function carritoPara(c) {
      if (eventos && eventos.CartLinesUpdateEvent) return eventos.CartLinesUpdateEvent.createCartFromAjaxResponse(c);
      return { totalQuantity: c.item_count };
    }
    function leerCarrito() {
      return fetch(raiz.dataset.urlCarrito + '.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
    }
    function resolver(listo, resp, agregadas, fallo) {
      leerCarrito().then(function (c) {
        listo.res({ cart: carritoPara(c), detail: { items: c.items, source: 'mrh-baterias', sourceId: 'mrh-baterias', itemCount: agregadas, sections: resp && resp.sections, didError: fallo } });
      }, listo.rej);
    }

    // ---- cada + agrega una batería sin salir de la página ----
    raiz.querySelectorAll('[data-mrh-bat-form]').forEach(function (form) {
      var btn = form.querySelector('button');
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (btn.disabled) return;
        btn.disabled = true;
        var items = [{ id: parseInt(form.querySelector('[name="id"]').value, 10), quantity: 1 }];
        var listo = {};
        var promesa = new Promise(function (res, rej) { listo.res = res; listo.rej = rej; });
        avisar(items, promesa);
        var cuerpo = { items: items }, secs = seccionesCarrito();
        if (secs) cuerpo.sections = secs;
        fetch(raiz.dataset.urlAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(cuerpo) })
          .then(function (r) {
            // Solo el mensaje de Shopify («ya no hay piezas…») se enseña tal cual; lo demás, el texto del ajuste.
            if (!r.ok) return r.json().then(function (j) { var x = new Error(j.description || j.message || r.status); x.mrh = true; throw x; });
            return r.json();
          })
          .then(function (resp) {
            btn.textContent = '✓'; btn.setAttribute('data-hecho', '');
            setTimeout(function () { btn.textContent = '+'; btn.removeAttribute('data-hecho'); }, 1600);
            if (aviso) {
              aviso.innerHTML = '';
              aviso.appendChild(document.createTextNode(raiz.dataset.textoHecho.replace('[color]', (form.dataset.color || '').toLowerCase()) + ' '));
              if (raiz.dataset.urlCarrito) {
                var a = document.createElement('a'); a.href = raiz.dataset.urlCarrito; a.textContent = raiz.dataset.textoPagar; aviso.appendChild(a);
              }
              aviso.hidden = false;
            }
            resolver(listo, resp, 1, false);
          })
          .catch(function (err) {
            if (aviso) { aviso.textContent = (err && err.mrh && err.message) || raiz.dataset.textoError; aviso.hidden = false; }
            resolver(listo, null, 0, true);
          })
          .then(function () { btn.disabled = false; });
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mrh-como-funciona"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-mrh-faq]').forEach(function (faq) {
    var qs = Array.prototype.slice.call(faq.querySelectorAll('details.mrh-cf__q'));
    // Una abierta a la vez: al abrir una, se cierran las demás.
    var cerrando = false;
    qs.forEach(function (q) {
      q.addEventListener('toggle', function () {
        if (!q.open || cerrando) return;
        cerrando = true;
        qs.forEach(function (o) { if (o !== q && o.open) o.open = false; });
        cerrando = false;
        if (q.id && history.replaceState) { try { history.replaceState(null, '', '#' + q.id); } catch (e) {} }
      });
    });
    // Llegar con ancla (#si-llega) abre esa pregunta.
    function abrirAncla() {
      var id = decodeURIComponent(location.hash.slice(1));
      if (!id) return;
      var q = document.getElementById(id);
      if (q && q.classList.contains('mrh-cf__q') && !q.open) q.open = true;
    }
    abrirAncla();
    window.addEventListener('hashchange', abrirAncla);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mrh-que-hay-hoy"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-mrh-qhh]').forEach(function (raiz) {
    var tabs = raiz.querySelectorAll('[data-mrh-qhh-tab]');
    var paneles = raiz.querySelectorAll('[data-mrh-qhh-panel]');
    var aviso = raiz.querySelector('[data-mrh-qhh-aviso]');

    // ---- pestañas: se enseña el panel del dispositivo elegido ----
    function mostrar() {
      var r = raiz.querySelector('[data-mrh-qhh-tab]:checked');
      if (!r) return;
      paneles.forEach(function (p) { p.hidden = p.dataset.mrhQhhPanel !== r.value; });
    }
    tabs.forEach(function (t) { t.addEventListener('change', mostrar); });
    mostrar();

    // ---- carrito de Horizon 3.5: mismo aviso que ARMA TU EMBARQUE ----
    var eventos = null;
    try { import('@shopify/events').then(function (m) { eventos = m; }, function () {}); } catch (e) {}
    function seccionesCarrito() {
      var ids = [];
      document.querySelectorAll('cart-items-component').forEach(function (c) { if (c.dataset.sectionId) ids.push(c.dataset.sectionId); });
      return ids.join(',');
    }
    function avisar(items, promesa) {
      var datos = { action: 'add', context: 'product', promise: promesa, lines: items.map(function (i) { return { merchandiseId: i.id, quantity: i.quantity }; }) };
      var ev;
      if (eventos && eventos.CartLinesUpdateEvent) ev = new eventos.CartLinesUpdateEvent(datos);
      else { ev = new Event('shopify:cart:lines-update', { bubbles: true, cancelable: true }); Object.assign(ev, datos); }
      raiz.dispatchEvent(ev);
    }
    function carritoPara(c) {
      if (eventos && eventos.CartLinesUpdateEvent) return eventos.CartLinesUpdateEvent.createCartFromAjaxResponse(c);
      return { totalQuantity: c.item_count };
    }
    function leerCarrito() {
      return fetch(raiz.dataset.urlCarrito + '.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
    }
    function resolver(listo, resp, agregadas, fallo) {
      leerCarrito().then(function (c) {
        listo.res({ cart: carritoPara(c), detail: { items: c.items, source: 'mrh-que-hay-hoy', sourceId: 'mrh-que-hay-hoy', itemCount: agregadas, sections: resp && resp.sections, didError: fallo } });
      }, listo.rej);
    }

    // ---- cada + agrega una pieza sin salir de la página ----
    raiz.querySelectorAll('[data-mrh-qhh-form]').forEach(function (form) {
      var btn = form.querySelector('button'), fila = form.closest('.mrh-qhh__fila'), chip = fila && fila.querySelector('[data-mrh-qhh-chip]');
      var veces = 0;
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (btn.disabled) return;
        btn.disabled = true;
        var id = parseInt(form.querySelector('[name="id"]').value, 10);
        var items = [{ id: id, quantity: 1 }];
        var listo = {};
        var promesa = new Promise(function (res, rej) { listo.res = res; listo.rej = rej; });
        avisar(items, promesa);
        var cuerpo = { items: items }, secs = seccionesCarrito();
        if (secs) cuerpo.sections = secs;
        fetch(raiz.dataset.urlAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(cuerpo) })
          .then(function (r) { if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || r.status); }); return r.json(); })
          .then(function (resp) {
            veces += 1;
            if (chip) { chip.textContent = raiz.dataset.textoHecho.replace('[n]', veces); chip.className = 'mrh-qhh__chip mrh-qhh__chip--hecho'; }
            if (aviso) {
              aviso.innerHTML = raiz.dataset.textoHecho.replace('[n]', veces).replace(/^./, function (m) { return m.toUpperCase(); }) + ' · ' + fila.querySelector('.mrh-qhh__nombre').textContent +
                (raiz.dataset.urlCarrito ? ' <a href="' + raiz.dataset.urlCarrito + '">IR A PAGAR</a>' : '');
              aviso.hidden = false;
            }
            resolver(listo, resp, 1, false);
          })
          .catch(function (err) {
            if (aviso) { aviso.textContent = err.message || raiz.dataset.textoError; aviso.hidden = false; }
            resolver(listo, null, 0, true);
          })
          .then(function () { btn.disabled = false; });
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mrh_cinta"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Tocar la cinta la pausa; tocar de nuevo la suelta. En escritorio ya
  // basta con el cursor encima. Si no hay animación (movimiento reducido)
  // no hace nada.
  document.querySelectorAll('[data-mrh-cinta]').forEach(function (cinta) {
    cinta.addEventListener('click', function (e) {
      if (e.target.closest('a')) return;
      if (cinta.hasAttribute('data-pausa')) cinta.removeAttribute('data-pausa');
      else cinta.setAttribute('data-pausa', '');
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mrh_coleccion"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-mrh-col]').forEach(function (raiz) {
    var radios = raiz.querySelectorAll('[data-mrh-col-dispositivo]');
    var tarjetas = raiz.querySelectorAll('[data-mrh-col-tarjeta]');
    if (!radios.length || !tarjetas.length) return;

    function mapa(t) {
      var m = {};
      (t.dataset.mapa || '').split(';;').forEach(function (trozo) {
        var p = trozo.split('|'); if (p.length >= 4) m[p[0]] = { nombre: p[0], id: p[1], precio: p[2], ok: p[3] === '1', img: p[4] || '', img800: p[5] || '', w: p[6] || '', h: p[7] || '' };
      });
      return m;
    }
    // TODOS (value vacío): el de por defecto si lo hay; si no, el primer
    // dispositivo que sí hay, en el orden de los chips.
    var porDefecto = raiz.dataset.dispositivoDefault || '';
    var orden = [];
    radios.forEach(function (r) { if (r.value) orden.push(r.value); });
    function mejor(m) {
      if (porDefecto && m[porDefecto] && m[porDefecto].ok) return m[porDefecto];
      for (var i = 0; i < orden.length; i++) { if (m[orden[i]] && m[orden[i]].ok) return m[orden[i]]; }
      return m[porDefecto] || null;
    }
    // Al cambiar de dispositivo, cada tarjeta muestra el precio de esa
    // variante y su enlace abre la ficha con ?variant= puesto.
    function aplicar() {
      var r = raiz.querySelector('[data-mrh-col-dispositivo]:checked');
      if (!r) return;
      var d = r.value;
      tarjetas.forEach(function (t) {
        if (t.hasAttribute('data-agotado') || t.hasAttribute('data-sin-opcion')) return;
        var m = mapa(t);
        var e = d ? m[d] : mejor(m);
        var precio = t.querySelector('[data-mrh-col-precio]');
        var dispo = t.querySelector('[data-mrh-col-dispo]');
        if (dispo) dispo.textContent = e ? e.nombre : d;
        if (e) {
          if (precio) precio.textContent = e.precio;
          t.href = t.dataset.url + '?variant=' + e.id;
          // La foto de la variante: el MrPen enseña el MrPen.
          var foto = t.querySelector('[data-mrh-col-foto]');
          if (foto && e.img && foto.getAttribute('src') !== e.img) {
            foto.srcset = e.img + ' 500w' + (e.img800 ? ', ' + e.img800 + ' 800w' : '');
            foto.src = e.img;
            if (e.w && e.h) { foto.width = e.w; foto.height = e.h; }
          }
          if (e.ok) t.removeAttribute('data-sin-dispositivo'); else t.setAttribute('data-sin-dispositivo', '');
        } else {
          t.href = t.dataset.url;
          t.setAttribute('data-sin-dispositivo', '');
        }
      });
    }
    radios.forEach(function (r) { r.addEventListener('change', aplicar); });

    // Llegar con ?dispositivo= (las filas del aviso de octubre): ese chip
    // queda elegido. Primero igual exacto; si no, el que empiece igual.
    function clave(s) {
      return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]/g, '');
    }
    var pedido = clave(new URLSearchParams(location.search).get('dispositivo'));
    if (pedido) {
      var elegido = null;
      radios.forEach(function (r) { if (!elegido && clave(r.value) === pedido) elegido = r; });
      radios.forEach(function (r) {
        var c = clave(r.value);
        if (!elegido && c && (pedido.indexOf(c) === 0 || c.indexOf(pedido) === 0)) elegido = r;
      });
      if (elegido) elegido.checked = true;
    }
    // Siempre una vez al cargar: el navegador puede devolver marcado otro
    // chip al volver atrás, y las tarjetas deben decir lo mismo que él.
    aplicar();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mrh_destacado"] && !Shopify.designMode) return;
  try {
    
(function () {
  // ---- la foto se ajusta a la pieza ----
  function recorte(img) {
    // Caja de la pieza dentro del archivo, en fracciones 0–1. Cuenta como
    // pieza todo píxel que no sea transparente ni casi blanco (fotos JPG
    // con fondo blanco). Se muestrea a 200 px de ancho: sobra.
    var w = 200, h = Math.max(1, Math.round(img.naturalHeight * w / img.naturalWidth));
    var c = document.createElement('canvas'); c.width = w; c.height = h;
    var ctx = c.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(img, 0, 0, w, h);
    var d;
    try { d = ctx.getImageData(0, 0, w, h).data; } catch (e) { return null; }
    var x0 = w, y0 = h, x1 = -1, y1 = -1;
    for (var y = 0; y < h; y++) for (var x = 0; x < w; x++) {
      var i = (y * w + x) * 4;
      if (d[i + 3] > 24 && (d[i] < 236 || d[i + 1] < 236 || d[i + 2] < 236)) {
        if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y;
      }
    }
    if (x1 < 0 || (x1 - x0) < 4 || (y1 - y0) < 4) return null;
    return { x: x0 / w, y: y0 / h, w: (x1 - x0 + 1) / w, h: (y1 - y0 + 1) / h };
  }
  function ajustarFoto(raiz) {
    var img = raiz.querySelector('[data-mrh-foto]');
    var cielo = raiz.querySelector('.mrh-des__cielo');
    if (!img || !cielo || raiz.getAttribute('data-foto-auto') !== '1') return;
    var zoom = (parseFloat(raiz.getAttribute('data-foto-zoom')) || 100) / 100;
    function aplicar() {
      if (!img.naturalWidth) return;
      var caja = img._mrhCaja;
      if (caja === undefined) { caja = img._mrhCaja = recorte(img); }
      if (!caja) return; // no se pudo leer: se queda el contain × zoom
      var R = cielo.getBoundingClientRect();
      if (!R.width || !R.height) return;
      // Tamaño con que se pinta el archivo completo (contain, 100 %).
      var s0 = Math.min(R.width / img.naturalWidth, R.height / img.naturalHeight);
      var dw = img.naturalWidth * s0, dh = img.naturalHeight * s0;
      // Escala para que la pieza ocupe el cielo con un poco de aire.
      var k = Math.min(R.width * 0.9 / (dw * caja.w), R.height * 0.9 / (dh * caja.h)) * zoom;
      var cx = caja.x + caja.w / 2, cy = caja.y + caja.h / 2;
      var tx = -(cx - 0.5) * dw * k, ty = -(cy - 0.5) * dh * k;
      img.style.setProperty('--mrh-foto-transform', 'translate(' + tx.toFixed(1) + 'px,' + ty.toFixed(1) + 'px) scale(' + k.toFixed(3) + ')');
      img.setAttribute('data-mrh-ajustada', '');
    }
    if (img.complete && img.naturalWidth) aplicar(); else img.addEventListener('load', aplicar);
    if ('ResizeObserver' in window) new ResizeObserver(aplicar).observe(cielo);
    else window.addEventListener('resize', aplicar);
  }

  document.querySelectorAll('[data-mrh-destacado]').forEach(function (raiz) {
    ajustarFoto(raiz);
    var grupo = raiz.querySelector('[data-mrh-niveles]');
    var nota = raiz.querySelector('[data-mrh-nota]');
    if (!grupo) return;
    var chips = Array.prototype.slice.call(grupo.querySelectorAll('[data-mrh-nivel]'));
    function elegir(chip) {
      chips.forEach(function (c) { c.setAttribute('aria-checked', c === chip ? 'true' : 'false'); });
      if (nota) nota.textContent = chip.getAttribute('data-nota') || '';
    }
    grupo.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-mrh-nivel]');
      if (chip) elegir(chip);
    });
    // Flechas entre chips, como un grupo de radios.
    grupo.addEventListener('keydown', function (e) {
      var i = chips.indexOf(document.activeElement);
      if (i < 0) return;
      var n = -1;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') n = (i + 1) % chips.length;
      if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') n = (i - 1 + chips.length) % chips.length;
      if (n < 0) return;
      e.preventDefault();
      chips[n].focus();
      elegir(chips[n]);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mrh_embarque"] && !Shopify.designMode) return;
  try {
    
/* Convierte los formularios de cada sabor en contadores y manda todo al
   carrito en un solo POST. Si no corre, cada formulario agrega uno por
   uno con la variante por defecto: la dirección segura del fallo. */
(function () {
  if (window.__mrhEmbarque) return;
  window.__mrhEmbarque = true;

  document.querySelectorAll('[data-mrh-embarque]').forEach(function (raiz) {
    var minCaja = +raiz.dataset.minCaja || 3, minEmb = +raiz.dataset.minEmbarque || 5;
    var barra = raiz.querySelector('[data-mrh-emb-barra]');
    var tramoEl = raiz.querySelector('[data-mrh-emb-tramo]');
    var textoEl = raiz.querySelector('[data-mrh-emb-texto]');
    var medidor = raiz.querySelector('[data-mrh-emb-medidor]');
    var btn = raiz.querySelector('[data-mrh-emb-agregar]');
    var hecho = raiz.querySelector('[data-mrh-emb-hecho]');
    var error = raiz.querySelector('[data-mrh-emb-error]');
    var forms = raiz.querySelectorAll('[data-mrh-emb-form]');
    if (!barra || !btn) return;
    barra.hidden = false;

    /* mapa "Dispo|id|1;;Dispo2|id|0" → {Dispo:{id, ok}}. El 1/0 lo escribe
       Liquid a propósito: un booleano renderizado cambia según el motor. */
    function mapa(form) {
      var m = {};
      (form.dataset.mapa || '').split(';;').forEach(function (t) {
        var p = t.split('|'); if (p.length === 3) m[p[0]] = { id: p[1], ok: p[2] === '1' };
      });
      return m;
    }
    function dispositivo() {
      var r = raiz.querySelector('[data-mrh-dispositivo]:checked');
      return r ? r.value : null;
    }
    /* al cambiar el dispositivo, cambia la variante de todas las tarjetas */
    function aplicarDispositivo() {
      var d = dispositivo();
      forms.forEach(function (form) {
        var m = mapa(form), v = d ? m[d] : null;
        var idEl = form.querySelector('[data-mrh-emb-id]');
        var mas = form.querySelector('[data-mrh-emb-mas]');
        if (v && v.ok) { idEl.value = v.id; form.removeAttribute('data-sin-dispositivo'); mas.disabled = form.hasAttribute('data-agotado'); }
        else if (d) { form.setAttribute('data-sin-dispositivo', ''); mas.disabled = true; poner(form, 0); }
      });
      pintar();
    }
    function n(form) { return +(form.querySelector('[data-mrh-emb-n]').value || 0); }
    function poner(form, v) {
      v = Math.max(0, v);
      form.querySelector('[data-mrh-emb-n]').value = v;
      form.querySelector('[data-mrh-emb-menos]').hidden = v === 0;
      form.classList.toggle('mrh-emb__tarjeta--con', v > 0);
    }
    // Con una sola pieza usa el texto en singular si el cliente lo llenó.
    function uno(t, clave) { return (t === 1 && raiz.dataset[clave + 'Uno']) ? raiz.dataset[clave + 'Uno'] : raiz.dataset[clave]; }
    function total() { var t = 0; forms.forEach(function (f) { t += n(f); }); return t; }
    function tramo(t) {
      if (t >= minEmb) return { nombre: raiz.dataset.nombreEmbarque, faltan: 0 };
      if (t >= minCaja) return { nombre: raiz.dataset.nombreCaja, faltan: minEmb - t, sig: raiz.dataset.nombreEmbarque };
      return { nombre: raiz.dataset.nombreSobre, faltan: minCaja - t, sig: raiz.dataset.nombreCaja };
    }
    function pintar() {
      var t = total(), tr = tramo(t);
      tramoEl.textContent = t === 0 ? raiz.dataset.nombreSobre : tr.nombre;
      if (t === 0) textoEl.textContent = raiz.dataset.textoVacio;
      else if (tr.faltan > 0) textoEl.textContent = uno(t, 'textoFaltan').replace('[n]', t).replace('[faltan]', tr.faltan).replace('[tramo]', tr.sig);
      else textoEl.textContent = raiz.dataset.textoTope.replace('[n]', t);
      medidor.style.width = Math.min(100, t / minEmb * 100) + '%';
      btn.disabled = t === 0;
      btn.textContent = uno(t, 'textoBoton').replace('[n]', t);
      hecho.hidden = true; error.hidden = true;
    }

    forms.forEach(function (form) {
      form.addEventListener('submit', function (e) { e.preventDefault(); poner(form, n(form) + 1); pintar(); });
      form.querySelector('[data-mrh-emb-menos]').addEventListener('click', function () { poner(form, n(form) - 1); pintar(); });
    });
    raiz.querySelectorAll('[data-mrh-dispositivo]').forEach(function (r) { r.addEventListener('change', aplicarDispositivo); });

    // Horizon 3.5: el cajón, la burbuja del icono y las fichas escuchan
    // `shopify:cart:lines-update` con una promesa que resuelve el carrito ya
    // actualizado. Sin ese aviso, el carrito no se entera hasta recargar.
    // La clase vive en el módulo `@shopify/events` del tema; si no carga,
    // se lanza el mismo evento a mano con la misma forma.
    var eventos = null;
    try { import('@shopify/events').then(function (m) { eventos = m; }, function () {}); } catch (e) {}
    function seccionesCarrito() {
      var ids = [];
      document.querySelectorAll('cart-items-component').forEach(function (c) { if (c.dataset.sectionId) ids.push(c.dataset.sectionId); });
      return ids.join(',');
    }
    function avisar(items, promesa) {
      var datos = {
        action: 'add', context: 'product', promise: promesa,
        lines: items.map(function (i) { return { merchandiseId: i.id, quantity: i.quantity }; })
      };
      var ev;
      if (eventos && eventos.CartLinesUpdateEvent) ev = new eventos.CartLinesUpdateEvent(datos);
      else { ev = new Event('shopify:cart:lines-update', { bubbles: true, cancelable: true }); Object.assign(ev, datos); }
      raiz.dispatchEvent(ev);
    }
    function carritoPara(c) {
      if (eventos && eventos.CartLinesUpdateEvent) return eventos.CartLinesUpdateEvent.createCartFromAjaxResponse(c);
      return { totalQuantity: c.item_count };
    }
    function leerCarrito() {
      return fetch(raiz.dataset.urlCarrito + '.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
    }
    function resolver(listo, resp, agregadas, fallo) {
      leerCarrito().then(function (c) {
        listo.res({ cart: carritoPara(c), detail: {
          items: c.items, source: 'mrh-embarque', sourceId: 'mrh-embarque',
          itemCount: agregadas, sections: resp && resp.sections, didError: fallo } });
      }, listo.rej);
    }

    btn.addEventListener('click', function () {
      var items = [];
      forms.forEach(function (f) {
        var q = n(f); if (q > 0) items.push({ id: +f.querySelector('[data-mrh-emb-id]').value, quantity: q });
      });
      if (!items.length || btn.dataset.mrhOcupado) return;
      btn.dataset.mrhOcupado = '1'; btn.disabled = true;
      var t = total();
      var listo = {};
      var promesa = new Promise(function (res, rej) { listo.res = res; listo.rej = rej; });
      avisar(items, promesa);
      var cuerpo = { items: items }, secs = seccionesCarrito();
      if (secs) cuerpo.sections = secs;
      fetch(raiz.dataset.urlAdd + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(cuerpo)
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || r.status); });
        return r.json();
      }).then(function (resp) {
        forms.forEach(function (f) { poner(f, 0); });
        pintar();
        hecho.innerHTML = uno(t, 'textoHecho').replace('[n]', t) +
          ' <a href="' + raiz.dataset.urlCarrito + '">' + (raiz.dataset.urlCarrito ? 'IR A PAGAR' : '') + '</a>';
        hecho.hidden = false;
        resolver(listo, resp, t, false);
      }).catch(function (err) {
        error.textContent = err.message || 'No se pudo agregar. Intenta otra vez.';
        error.hidden = false; btn.disabled = false;
        resolver(listo, null, 0, true);
      }).then(function () { delete btn.dataset.mrhOcupado; });
    });

    aplicarDispositivo();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mrh_empujon"] && !Shopify.designMode) return;
  try {
    
(function () {
  var raiz = document.querySelector('[data-mrh-empujon]');
  if (!raiz) return;
  var datos = { sabores: [], codigos: [] };
  try { datos = JSON.parse(raiz.querySelector('[data-mrh-emp-datos]').textContent); } catch (e) {}
  if (!datos.codigos) datos.codigos = [];
  // Las piezas que suben de tramo: solo las de la colección de sabores (la
  // del descuento automático). Si una línea llega sin product_id (eventos
  // del tema), se usa el total hasta que /cart.js traiga el carrito entero.
  var cuentan = {};
  (datos.cuentan || []).forEach(function (id) { cuentan[String(id)] = true; });
  var hayLista = (datos.cuentan || []).length > 0;
  function piezas(c) {
    var items = c.items || [];
    if (!hayLista || !items.length) return c.item_count || 0;
    var n = 0, sinId = false;
    items.forEach(function (i) {
      if (i.product_id == null) sinId = true;
      else if (cuentan[String(i.product_id)]) n += i.quantity || 0;
    });
    return sinId ? (c.item_count || 0) : n;
  }
  var escNecesaria = true; // false cuando el carrito solo trae lo que no es sabor
  var cfg = raiz.dataset;
  var minCaja = parseInt(cfg.minCaja, 10) || 3, minEmb = parseInt(cfg.minEmbarque, 10) || 5, cuantos = parseInt(cfg.cuantos, 10) || 3;
  function dinero(centavos, moneda) {
    try { return new Intl.NumberFormat('es-MX', { style: 'currency', currency: moneda || 'MXN', maximumFractionDigits: 2 }).format((centavos || 0) / 100); }
    catch (e) { return '$' + ((centavos || 0) / 100).toFixed(2); }
  }
  var escapar = function (s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };

  // ---- el carrito de Horizon: mismo aviso que las demás secciones ----
  var eventos = null;
  try { import('@shopify/events').then(function (m) { eventos = m; }, function () {}); } catch (e) {}
  function seccionesCarrito() {
    var ids = [];
    document.querySelectorAll('cart-items-component').forEach(function (c) { if (c.dataset.sectionId) ids.push(c.dataset.sectionId); });
    return ids.join(',');
  }
  function leerCarrito() {
    return fetch(cfg.urlCarrito + '.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
  }
  function carritoPara(c) {
    if (eventos && eventos.CartLinesUpdateEvent) return eventos.CartLinesUpdateEvent.createCartFromAjaxResponse(c);
    return { totalQuantity: c.item_count };
  }
  function lanzar(nombreClase, nombreEvento, base, origen) {
    var ev;
    if (eventos && eventos[nombreClase]) ev = new eventos[nombreClase](base);
    else { ev = new Event(nombreEvento, { bubbles: true, cancelable: true }); Object.assign(ev, base); }
    (origen || document.body).dispatchEvent(ev);
  }
  function agregar(variantId, origen) {
    var items = [{ id: variantId, quantity: 1 }];
    var listo = {};
    var promesa = new Promise(function (res, rej) { listo.res = res; listo.rej = rej; });
    lanzar('CartLinesUpdateEvent', 'shopify:cart:lines-update', { action: 'add', context: 'cart', promise: promesa, lines: [{ merchandiseId: variantId, quantity: 1 }] }, origen);
    var cuerpo = { items: items }, secs = seccionesCarrito();
    if (secs) cuerpo.sections = secs;
    return fetch(cfg.urlAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(cuerpo) })
      .then(function (r) { if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || r.status); }); return r.json(); })
      .then(function (resp) {
        return leerCarrito().then(function (c) {
          ultimo = c; pintar(c);
          listo.res({ cart: carritoPara(c), detail: { items: c.items, source: 'mrh-empujon', sourceId: 'mrh-empujon', itemCount: 1, sections: resp.sections, didError: false } });
        });
      })
      .catch(function (err) {
        leerCarrito().then(function (c) { listo.res({ cart: carritoPara(c), detail: { items: c.items, source: 'mrh-empujon', sourceId: 'mrh-empujon', itemCount: 0, didError: true } }); }, listo.rej);
        throw err;
      });
  }
  // Aplicar o quitar un código: /cart/update.js con `discount`, y el aviso
  // de descuento que escucha el cajón para recalcular el total.
  // Devuelve { carrito, antes }: `antes` es el total con lo que hubiera
  // (la escalera automática, u otro código) para poder comparar.
  // Horizon, al recibir el evento de código, hace morph del cajón con el HTML
  // de la sección y el <dialog> vuelve a nacer cerrado; para líneas lo reabre
  // él mismo, para códigos no. Se reabre aquí si estaba abierto.
  function cajonAbierto() {
    var cd = document.querySelector('#cart-drawer');
    if (!cd) return false;
    var dlg = cd.querySelector('dialog');
    return dlg ? !!dlg.open : false;
  }
  function reabrirCajon() {
    var cd = document.querySelector('#cart-drawer');
    if (!cd || cajonAbierto()) return;
    try { if (typeof cd.open === 'function') cd.open(); else { var dlg = cd.querySelector('dialog'); if (dlg && dlg.showModal) dlg.showModal(); } } catch (e) {}
  }
  function aplicarCodigo(codigo, origen) {
    var listo = {};
    var estabaAbierto = cajonAbierto();
    var promesa = new Promise(function (res, rej) { listo.res = res; listo.rej = rej; });
    lanzar('CartDiscountUpdateEvent', 'shopify:cart:discount-update', { action: codigo ? 'add' : 'remove', codes: codigo ? [codigo] : [], promise: promesa }, origen);
    var cuerpo = { discount: codigo || '' }, secs = seccionesCarrito();
    if (secs) cuerpo.sections = secs;
    var antes = null;
    var pedir = function (cuerpoX) { return fetch(cfg.urlUpdate + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(cuerpoX) }).then(function (r) { if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || r.status); }); return r.json(); }); };
    return leerCarrito().then(function (c0) {
        // La comparación es siempre contra la escalera (sin código). Si ya
        // había un código, se quita primero y ese total es el «antes».
        if (codigo && c0.discount_codes && c0.discount_codes.length) return pedir({ discount: '' }).then(function (c1) { antes = c1; });
        antes = c0;
      }).catch(function () {})
      .then(function () { return fetch(cfg.urlUpdate + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(cuerpo) }); })
      .then(function (r) { if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || r.status); }); return r.json(); })
      .then(function (c) {
        ultimo = c; pintar(c);
        listo.res({ cart: carritoPara(c), detail: { items: c.items, source: 'mrh-empujon', sourceId: 'mrh-empujon', sections: c.sections, didError: false } });
        if (estabaAbierto) [0, 250, 800].forEach(function (ms) { setTimeout(function () { reabrirCajon(); refrescar(); }, ms); });
        // La respuesta de update.js a veces trae los códigos viejos: la
        // verdad se lee de /cart.js y se repinta con ella.
        return leerCarrito().then(function (c2) { ultimo = c2; pintar(c2); return { carrito: c2, antes: antes }; })
          .catch(function () { return { carrito: c, antes: antes }; });
      })
      .catch(function (err) { listo.rej(err); throw err; });
  }

  // ---- el estado ----
  var ultimo = null;
  var listaAbierta = false;
  // La nota del código vive en el estado, no en el DOM: Horizon repinta el
  // cajón entero después de aplicar un código y se llevaba el mensaje
  // (visto el 7 de septiembre con un 2x1 que no aplicaba).
  var notaEstado = null; // { texto, volver }
  var manualTexto = '';   // lo que va escrito en el campo manual
  var eleccion = {};      // sabor.id -> dispositivo elegido en su tarjeta
  // El código que de verdad aplica ahora mismo (Shopify manda uno solo).
  function codigoActual(c) {
    var ap = codigosAplicados(c || ultimo || {});
    for (var k in ap) if (ap[k] === true) return k;
    return '';
  }
  function tramo(t) {
    if (t >= minEmb) return { i: 2, nombre: cfg.nombreEmbarque, faltan: 0 };
    if (t >= minCaja) return { i: 1, nombre: cfg.nombreCaja, faltan: minEmb - t, sig: cfg.nombreEmbarque };
    return { i: 0, nombre: cfg.nombreSobre, faltan: minCaja - t, sig: cfg.nombreCaja };
  }
  function dispositivoDe(c) {
    var cuenta = {};
    (c.items || []).forEach(function (i) {
      var d = (i.options_with_values || []).filter(function (o) { return (o.name || '').toLowerCase() === 'dispositivo'; })[0];
      var v = d ? d.value : (i.variant_title || '');
      if (v) cuenta[v] = (cuenta[v] || 0) + i.quantity;
    });
    var mejor = null, max = 0;
    Object.keys(cuenta).forEach(function (k) { if (cuenta[k] > max) { max = cuenta[k]; mejor = k; } });
    return mejor || cfg.dispositivoDefault || '';
  }
  // El dispositivo de cada tarjeta: el que la persona eligió en esa
  // tarjeta; si no, el que más lleva en el carrito; si ese no hay, el
  // primero con piezas. Así un sabor sin MrMini sigue saliendo, en MrPen.
  function dispositivoPara(s, dispo) {
    var e = eleccion[s.id];
    if (e && s.variantes[e] && s.variantes[e].ok) return e;
    if (s.variantes[dispo] && s.variantes[dispo].ok) return dispo;
    for (var k in s.variantes) if (s.variantes[k].ok) return k;
    return '';
  }
  function candidatos(c) {
    var enCarrito = {};
    (c.items || []).forEach(function (i) { enCarrito[i.product_id] = true; });
    var dispo = dispositivoDe(c);
    return datos.sabores.filter(function (s) {
      return !enCarrito[s.id] && s.disponible && dispositivoPara(s, dispo);
    }).slice(0, cuantos).map(function (s) { var d = dispositivoPara(s, dispo); return { s: s, variante: s.variantes[d].id, dispo: d }; });
  }
  // En 105 px no cabe «MrMini 2g»: si el primer nombre (MrPen, MrMini) es
  // único entre las variantes se quita la medida; MrTank 3g / 5g la conservan.
  function etiquetaCorta(k, todos) {
    var base = String(k).split(' ')[0];
    var iguales = todos.filter(function (o) { return String(o).split(' ')[0] === base; }).length;
    return iguales > 1 ? k : base;
  }
  function claveDe(lista) { return lista.map(function (x) { return x.s.id + ':' + x.variante; }).join(','); }
  // Por qué un código no aplica, según las reglas del bloque. Vacío = aplica.
  function razonNoAplica(k, c) {
    var items = c.items || [];
    var total = c.item_count || 0;
    if (k.requiere) {
      // Las líneas que llegan por los eventos de Horizon vienen sin
      // options_with_values (visto el 7 de septiembre: «No llevas MrTank 5g»
      // con dos MrTank 5g en el carrito). Se mira también el título de la
      // línea («Tutsi Pop - MrTank 5g») y, si ninguna línea trae con qué
      // decidir, la regla no se aplica: Shopify dirá al aplicar.
      var req = k.requiere.toLowerCase(), conDatos = false;
      var tiene = items.some(function (i) {
        var d = (i.options_with_values || []).filter(function (o) { return (o.name || '').toLowerCase() === 'dispositivo'; })[0];
        var v = ((d ? d.value : '') + ' ' + (i.variant_title || '') + ' ' + (i.title || '') + ' ' + (i.product_title ? '' : '')).toLowerCase();
        if (v.trim()) conDatos = true;
        return v.indexOf(req) !== -1;
      });
      if (conDatos && !tiene) return (cfg.textoRequiere || 'No llevas [dispositivo]').replace('[dispositivo]', k.requiere);
    }
    if (k.min && total < k.min) return (cfg.textoMin || 'Necesita [n] piezas').replace('[n]', k.min);
    if (k.sabores) {
      var ids = String(k.sabores).split(',').filter(Boolean);
      var hay = items.some(function (i) { return ids.indexOf(String(i.product_id)) !== -1; });
      if (!hay) return cfg.textoSabores || 'Solo con los sabores incluidos';
    }
    return '';
  }
  function codigosAplicados(c) {
    var m = {};
    (c.discount_codes || []).forEach(function (d) { if (d && d.code) m[String(d.code).toUpperCase()] = d.applicable !== false; });
    return m;
  }

  // ---- el HTML ----
  function textoLinea(t) {
    var tr = tramo(t), piezas = t === 1 ? cfg.textoPieza : cfg.textoPiezas;
    if (tr.faltan > 0) return ((t === 1 && cfg.textoFaltanUno) ? cfg.textoFaltanUno : cfg.textoFaltan).replace('[n]', t).replace('[piezas]', piezas).replace('[faltan]', tr.faltan).replace('[tramo]', tr.sig);
    return cfg.textoTope.replace('[n]', t).replace('[piezas]', piezas);
  }
  function htmlEscalera(t, c) {
    var tr = tramo(t);
    var rangos = ['1' + (minCaja - 1 > 1 ? '–' + (minCaja - 1) : ''), minCaja + (minEmb - 1 > minCaja ? '–' + (minEmb - 1) : ''), minEmb + '+'];
    var nombres = [cfg.nombreSobre, cfg.nombreCaja, cfg.nombreEmbarque];
    var lis = nombres.map(function (n, i) { return '<li' + (i === tr.i ? ' aria-current="true"' : '') + '><b>' + escapar(n) + '</b> <span>' + escapar(rangos[i]) + '</span></li>'; }).join('');
    var rayas = '';
    for (var k = 0; k < minEmb; k++) rayas += '<i' + (k < t ? ' data-lleno' : '') + '></i>';
    return '<div class="mrh-empu mrh-empu--escalera" data-mrh-empu="escalera"><ol class="mrh-empu__escalera">' + lis + '</ol>' +
      '<span class="mrh-empu__barra" aria-hidden="true">' + rayas + '</span><p class="mrh-empu__linea">' + escapar(textoLinea(t)) + '</p></div>';
  }
  // Arriba del botón de pagar: el de la página o el del cajón, según dónde se pinte.
  function ctasDe(o) {
    var lista = document.querySelectorAll('.cart__ctas');
    for (var i = 0; i < lista.length; i++) {
      var enCajon = !!lista[i].closest('#cart-drawer');
      if (o.antes ? !enCajon : enCajon) return lista[i];
    }
    return null;
  }
  // TU CÓDIGO va en su propio bloque, debajo de los productos del carrito,
  // para que no se confunda con la escalera (pedido del cliente, 7 de
  // septiembre).
  function htmlCodigos(c) {
    var codigos = '';
    if (cfg.mostrarCodigos === '1' && datos.codigos.length) {
      var aplicados = codigosAplicados(c);
      var activo = datos.codigos.filter(function (k) { return aplicados[k.codigo] === true; })[0] || null;
      var actual = codigoActual(c);
      if (!activo && actual) activo = { codigo: actual, etiqueta: actual, descripcion: cfg.textoManualDesc || '' };
      var campo = '<span class="mrh-empu__cod-valor">' + (activo
        ? '<b>' + escapar(activo.etiqueta) + '</b>' + (activo.descripcion ? '<span>' + escapar(activo.descripcion) + '</span>' : '')
        : '<span>' + escapar(cfg.textoElegir || 'Elegir') + '</span>') + '</span>';
      var filas = datos.codigos.map(function (k) {
        var razon = razonNoAplica(k, c), on = aplicados[k.codigo] === true;
        // Shopify ya dijo que no aplica (el bloque no traía la regla): se marca igual.
        if (!razon && aplicados.hasOwnProperty(k.codigo) && aplicados[k.codigo] === false) razon = cfg.textoCodigoNoAplica;
        var desc = razon || k.descripcion || '';
        return '<li><button type="button" class="mrh-empu__cod-op" role="radio" data-mrh-empu-codigo="' + escapar(k.codigo) + '" aria-checked="' + (on ? 'true' : 'false') + '"' + (razon ? ' aria-disabled="true"' : '') + '>' +
          '<b>' + escapar(k.etiqueta) + '</b><small>' + escapar(desc) + '</small>' +
          (razon ? '<span class="mrh-empu__cod-tag">' + escapar(cfg.textoNoAplicaTag || 'NO APLICA') + '</span>' : '<span class="mrh-empu__cod-radio" aria-hidden="true"></span>') +
          '</button></li>';
      }).join('');
      filas += '<li><button type="button" class="mrh-empu__cod-op" role="radio" data-mrh-empu-codigo="" aria-checked="' + (activo ? 'false' : 'true') + '"><b>' + escapar(cfg.textoSinCodigo || 'NINGUNO') + '</b><small>' + escapar(cfg.textoQuitar || '') + '</small><span class="mrh-empu__cod-radio" aria-hidden="true"></span></button></li>';
      // Campo manual: otro código o tarjeta de regalo.
      filas += '<li class="mrh-empu__cod-manual"><input type="text" class="mrh-empu__cod-input" data-mrh-empu-manual value="' + escapar(manualTexto) + '" placeholder="' + escapar(cfg.textoManual || 'Otro código o tarjeta de regalo') + '" autocomplete="off" autocapitalize="characters" spellcheck="false" aria-label="' + escapar(cfg.textoManual || 'Otro código o tarjeta de regalo') + '">' +
        '<button type="button" class="mrh-empu__cod-aplicar" data-mrh-empu-aplicar>' + escapar(cfg.textoAplicar || 'APLICAR') + '</button></li>';
      codigos = '<div class="mrh-empu__cod"><div class="mrh-empu__cod-fila"><span class="mrh-empu__kicker" style="margin:0">' + escapar(cfg.textoCodigos) + '</span>' +
        '<button type="button" class="mrh-empu__cod-campo" data-mrh-empu-cod-campo aria-expanded="' + (listaAbierta ? 'true' : 'false') + '">' + campo + '<i aria-hidden="true"></i></button></div>' +
        '<ul class="mrh-empu__cod-lista" role="radiogroup" data-mrh-empu-cod-lista' + (listaAbierta ? '' : ' hidden') + '>' + filas + '</ul>' +
        '<p class="mrh-empu__codigo-nota" data-mrh-empu-codigo-nota' + (notaEstado ? '' : ' hidden') + '>' +
        (notaEstado ? escapar(notaEstado.texto) + (notaEstado.volver ? ' <button type="button" class="mrh-empu__volver" data-mrh-empu-volver>' + escapar(cfg.textoVolver || 'VOLVER A LA ESCALERA') + '</button>' : '') : '') +
        '</p></div>';
    }
    if (!codigos) return '';
    return '<div class="mrh-empu mrh-empu--codigos" data-mrh-empu="codigos">' + codigos + '</div>';
  }
  function htmlSugerencias(lista) {
    if (!lista.length) return '';
    var tarjetas = lista.map(function (x) {
      var v = x.s.variantes[x.dispo] || {}, src = v.img || x.s.img;
      var img = '<img src="' + escapar(src || '') + '" alt="" loading="lazy" data-mrh-empu-img' + (src ? '' : ' hidden') + '>';
      // La lista de dispositivos del sabor; los que no tienen piezas se ven pero no se eligen.
      var claves = Object.keys(x.s.variantes);
      var ops = claves.map(function (k) {
        var vk = x.s.variantes[k];
        return '<option value="' + escapar(k) + '"' + (k === x.dispo ? ' selected' : '') + (vk.ok ? '' : ' disabled') + '>' + escapar(etiquetaCorta(k, claves)) + (vk.ok ? '' : ' · ' + escapar(cfg.textoAgotado || 'agotado')) + '</option>';
      }).join('');
      return '<li data-sabor="' + x.s.id + '"><div class="mrh-empu__tarjeta mrh-empu__tarjeta--' + escapar(x.s.cielo) + '"><span class="mrh-empu__cielo" aria-hidden="true">' + img + '</span>' +
        '<span class="mrh-empu__base"><span class="mrh-empu__nombre">' + escapar(x.s.titulo) + '</span>' +
        '<select class="mrh-empu__dispo" data-mrh-empu-dispo="' + x.s.id + '" aria-label="' + escapar(cfg.textoDispositivo || 'Dispositivo') + ' ' + escapar(x.s.titulo) + '">' + ops + '</select>' +
        '<button type="button" class="mrh-empu__mas" data-mrh-empu-mas="' + x.variante + '" aria-label="' + escapar(cfg.ariaAgregar) + ' ' + escapar(x.s.titulo) + ', ' + escapar(x.dispo) + '">+</button></span></div></li>';
    }).join('');
    return '<div class="mrh-empu mrh-empu--sugerencias" data-mrh-empu="sugerencias"><p class="mrh-empu__kicker">' + escapar(cfg.textoSugerencias) + '</p><ul class="mrh-empu__fila">' + tarjetas + '</ul><p class="mrh-empu__error" hidden role="alert"></p></div>';
  }

  // ---- dónde se inserta ----
  function objetivos() {
    var cajon = document.querySelector('#cart-drawer .cart-drawer__content');
    if (cajon) {
      return { arriba: cajon.querySelector('#cart-drawer-heading') || cajon.firstElementChild, dentro: cajon.querySelector('.cart-drawer__items'), abajo: cajon.querySelector('.cart-drawer__summary'), contenedor: cajon };
    }
    if (cfg.enPagina === '1') {
      var pagina = document.querySelector('main cart-items-component, #MainContent cart-items-component, cart-items-component');
      // La escalera va antes del componente; TU CÓDIGO y AGREGA OTRO SABOR
      // dentro de la columna de productos (.cart-page__items), así quedan
      // debajo de la lista y arriba del resumen «Total estimado» (pedido
      // del cliente, 8 de septiembre). Sin esa columna, después del componente.
      if (pagina && !pagina.closest('#cart-drawer')) return { arriba: pagina, dentro: pagina.querySelector('.cart-page__items'), abajo: null, contenedor: pagina.parentElement, antes: true };
    }
    return null;
  }
  function crear(html) { var d = document.createElement('div'); d.innerHTML = html; return d.firstElementChild; }
  function enganchar(el) {
    // El cajón de Horizon cierra si, al terminar un clic, el elemento tocado ya
    // no está dentro del <dialog> (isClickedOutside → !panel.contains(target)).
    // Nuestros botones cambian atributos, el MutationObserver repinta en el
    // microtask entre oyentes y el botón tocado queda fuera del DOM: el
    // cajón se cerraba al elegir un código o NINGUNO. Los clics dentro de
    // nuestros bloques no le llegan al cajón: aquí terminan.
    el.addEventListener('click', function (e) { e.stopPropagation(); });
    el.querySelectorAll('[data-mrh-empu-mas]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.disabled) return;
        b.disabled = true; el.setAttribute('data-ocupado', '');
        agregar(parseInt(b.dataset.mrhEmpuMas, 10), b).catch(function (err) {
          var er = el.querySelector('.mrh-empu__error');
          if (er) { er.textContent = err.message || 'No se pudo agregar.'; er.hidden = false; }
          b.disabled = false;
        }).then(function () { el.removeAttribute('data-ocupado'); });
      });
    });
    el.querySelectorAll('[data-mrh-empu-dispo]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var id = sel.dataset.mrhEmpuDispo, s = null;
        datos.sabores.forEach(function (x) { if (String(x.id) === String(id)) s = x; });
        var v = s && s.variantes[sel.value];
        if (!v) return;
        eleccion[id] = sel.value;
        var li = sel.closest('li'), img = li.querySelector('[data-mrh-empu-img]'), mas = li.querySelector('[data-mrh-empu-mas]');
        var src = v.img || s.img;
        if (img) { if (src) { img.src = src; img.hidden = false; } else { img.hidden = true; } }
        if (mas) { mas.dataset.mrhEmpuMas = v.id; mas.disabled = !v.ok; mas.setAttribute('aria-label', cfg.ariaAgregar + ' ' + s.titulo + ', ' + sel.value); }
        // La clave del bloque sigue a la elección: el próximo repintado no lo reconstruye.
        el.dataset.clave = claveDe(candidatos(ultimo || { item_count: 0 }));
      });
    });
    var campo = el.querySelector('[data-mrh-empu-cod-campo]');
    if (campo) campo.addEventListener('click', function () {
      listaAbierta = !listaAbierta;
      campo.setAttribute('aria-expanded', listaAbierta ? 'true' : 'false');
      var lista = el.querySelector('[data-mrh-empu-cod-lista]');
      if (lista) lista.hidden = !listaAbierta;
    });
    var volverBtn = el.querySelector('[data-mrh-empu-volver]');
    if (volverBtn) volverBtn.addEventListener('click', function () {
      volverBtn.disabled = true;
      notaEstado = null;
      aplicarCodigo('', volverBtn).catch(function () { volverBtn.disabled = false; });
    });
    el.querySelectorAll('[data-mrh-empu-codigo]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.getAttribute('aria-disabled') === 'true') {
          // Apagada: solo se explica por qué. No se llama al servidor.
          notaEstado = { texto: b.querySelector('small').textContent };
          listaAbierta = true;
          pintar(ultimo || { item_count: 0 });
          return;
        }
        var cod = b.dataset.mrhEmpuCodigo;
        // Se compara con el código real del carrito, no con el aria-checked
        // pintado: así siempre se puede volver al que ya se tenía.
        if (cod === codigoActual(ultimo)) { listaAbierta = false; notaEstado = null; pintar(ultimo || { item_count: 0 }); return; }
        elegirCodigo(cod, b, false);
      });
    });
    var manual = el.querySelector('[data-mrh-empu-manual]');
    var aplicarBtn = el.querySelector('[data-mrh-empu-aplicar]');
    if (manual) manual.addEventListener('input', function () { manualTexto = manual.value; });
    if (manual) manual.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); if (aplicarBtn) aplicarBtn.click(); } });
    if (aplicarBtn) aplicarBtn.addEventListener('click', function () {
      var cod = (manual ? manual.value : '').trim().toUpperCase();
      if (!cod) { if (manual) manual.focus(); return; }
      manualTexto = '';
      elegirCodigo(cod, aplicarBtn, true);
    });
    function elegirCodigo(cod, b, manualmente) {
        el.querySelectorAll('[data-mrh-empu-codigo], [data-mrh-empu-aplicar]').forEach(function (x) { x.disabled = true; });
        el.setAttribute('data-ocupado', '');
        listaAbierta = !!manualmente && false;
        notaEstado = null;
        aplicarCodigo(cod, b).then(function (r) {
          var c = r.carrito, antes = r.antes;
          var ap = codigosAplicados(c);
          if (!cod) { notaEstado = null; pintar(c); return; }
          if (!ap.hasOwnProperty(cod) || ap[cod] === false) {
            // Shopify lo rechazó para este carrito: se avisa, se deja la
            // lista abierta con la fila marcada y se quita el código para
            // que no quede pegado al pedido. Si venía del campo manual,
            // puede ser una tarjeta de regalo: esas entran en la pantalla de pago.
            // Si el pedido ya trae la escalera automática y no hay código
            // aplicado, lo más probable es que el código no se combine con ella.
            var conEscalera = (c.total_discount || 0) > 0 && !(c.discount_codes || []).some(function (d) { return d && d.applicable; });
            var base = (conEscalera && cfg.textoNoCombina) ? cfg.textoNoCombina : cfg.textoCodigoNoAplica;
            notaEstado = { texto: base + (manualmente && cfg.textoRegalo ? ' ' + cfg.textoRegalo : '') };
            listaAbierta = true;
            pintar(c);
            return aplicarCodigo('', b).catch(function () {});
          }
          // Conveniencia: total con el código contra el total de antes
          // (la escalera automática). Si sube, aviso y vuelta con un toque.
          var texto = cfg.textoCodigoAplicado.replace('[codigo]', cod), volver = false;
          if (antes && typeof antes.total_price === 'number' && typeof c.total_price === 'number') {
            var dif = c.total_price - antes.total_price;
            var monto = dinero(Math.abs(dif), c.currency);
            if (dif > 0) { texto = (cfg.textoPagasMas || 'Con este código pagas [monto] más que con la escalera.').replace('[monto]', monto); volver = true; }
            else if (dif < 0) texto = (cfg.textoAhorrasMas || 'Ahorras [monto] más que con la escalera.').replace('[monto]', monto);
            else texto = (cfg.textoIgual || 'Mismo precio que con la escalera.');
          }
          notaEstado = { texto: texto, volver: volver };
          pintar(c);
        }).catch(function (err) {
          notaEstado = { texto: err.message || cfg.textoCodigoNoAplica };
          pintar(ultimo || { item_count: 0 });
        }).then(function () {
          document.querySelectorAll('[data-mrh-empu]').forEach(function (esc) { esc.querySelectorAll('[data-mrh-empu-codigo], [data-mrh-empu-aplicar]').forEach(function (x) { x.disabled = false; }); esc.removeAttribute('data-ocupado'); });
        });
    }
  }
  // Pintar sin parpadeo: si ya hay bloques, se actualizan en su sitio; solo
  // se crean cuando no existen o el cajón los borró al repintar.
  // Si el cajón muestra la plantilla de «vacío» pero el carrito tiene
  // piezas (abierto desde un estado viejo), se le pide a Horizon que lo
  // repinte una vez. Medido el 7 de septiembre en la preview.
  var repintando = false;
  function repintarCajonSiViejo(t) {
    if (t <= 0 || repintando) return;
    if (!document.querySelector('#cart-drawer [data-cart-drawer-empty]')) return;
    repintando = true;
    try {
      import('@theme/section-renderer').then(function (m) {
        return m.sectionRenderer.renderSection('cart-drawer-section', { cache: false, mode: 'hydration' });
      }).catch(function () {}).then(function () { setTimeout(function () { repintando = false; refrescar(); }, 100); });
    } catch (e) { repintando = false; }
  }
  function pintar(c) {
    var o = objetivos();
    if (!o) return;
    var t = c.item_count || 0;
    repintarCajonSiViejo(t);
    if (t === 0) { document.querySelectorAll('[data-mrh-empu]').forEach(function (e) { e.remove(); }); return; }
    var esc = document.querySelector('[data-mrh-empu="escalera"]');
    var tEsc = piezas(c);
    escNecesaria = cfg.mostrarEscalera !== '0' && tEsc > 0;
    if (!escNecesaria) { if (esc) esc.remove(); }
    else {
      var nuevoEsc = crear(htmlEscalera(tEsc, c));
      if (esc && esc.isConnected) {
        while (esc.firstChild) esc.removeChild(esc.firstChild);
        while (nuevoEsc.firstChild) esc.appendChild(nuevoEsc.firstChild);
        enganchar(esc);
      } else {
        if (o.antes) o.arriba.parentElement.insertBefore(nuevoEsc, o.arriba);
        else if (o.arriba && o.arriba.id === 'cart-drawer-heading') o.arriba.insertAdjacentElement('afterend', nuevoEsc);
        else o.contenedor.insertBefore(nuevoEsc, o.contenedor.firstChild);
        enganchar(nuevoEsc);
      }
    }
    // Cómo se paga: solo se crea si falta; nunca se repinta en su sitio, así
    // el observador del cajón no entra en bucle con él.
    if (cfg.textoPago) {
      var ctas = ctasDe(o);
      var pago = ctas && ctas.parentElement.querySelector('[data-mrh-empu="pago"]');
      if (ctas && !pago) ctas.insertAdjacentElement('beforebegin', crear('<p class="mrh-empu mrh-empu--pago" data-mrh-empu="pago">' + escapar(cfg.textoPago) + '</p>'));
    }
    var htmlCod = htmlCodigos(c);
    var cod = document.querySelector('[data-mrh-empu="codigos"]');
    if (!htmlCod) { if (cod) cod.remove(); }
    else {
      var nuevoCod = crear(htmlCod);
      if (cod && cod.isConnected) {
        while (cod.firstChild) cod.removeChild(cod.firstChild);
        while (nuevoCod.firstChild) cod.appendChild(nuevoCod.firstChild);
        enganchar(cod);
      } else {
        var sugAntes = document.querySelector('[data-mrh-empu="sugerencias"]');
        if (o.dentro) { if (sugAntes && sugAntes.parentElement === o.dentro) o.dentro.insertBefore(nuevoCod, sugAntes); else o.dentro.appendChild(nuevoCod); }
        else if (o.abajo) o.abajo.insertAdjacentElement('beforebegin', nuevoCod);
        else if (o.antes) o.arriba.insertAdjacentElement('afterend', nuevoCod);
        else o.contenedor.appendChild(nuevoCod);
        enganchar(nuevoCod);
      }
    }
    var lista = candidatos(c);
    var sug = document.querySelector('[data-mrh-empu="sugerencias"]');
    var clave = claveDe(lista);
    if (!lista.length) { if (sug) sug.remove(); return; }
    if (sug && sug.isConnected && sug.dataset.clave === clave) return;
    var nuevoSug = crear(htmlSugerencias(lista)); nuevoSug.dataset.clave = clave;
    if (sug && sug.isConnected) sug.replaceWith(nuevoSug);
    else if (o.dentro) o.dentro.appendChild(nuevoSug);
    else if (o.abajo) o.abajo.insertAdjacentElement('beforebegin', nuevoSug);
    else if (o.antes) o.arriba.insertAdjacentElement('afterend', nuevoSug);
    else o.contenedor.appendChild(nuevoSug);
    enganchar(nuevoSug);
  }
  var pidiendo = false;
  function refrescar() {
    if (ultimo) pintar(ultimo);
    if (pidiendo) return;
    pidiendo = true;
    leerCarrito().then(function (c) { ultimo = c; pintar(c); }).catch(function () {}).then(function () { pidiendo = false; });
  }

  // ---- cuándo ----
  // Con el aviso del tema llega el carrito ya actualizado: se pinta al
  // momento con esos datos, sin esperar otra petición.
  document.addEventListener('shopify:cart:lines-update', function (e) {
    if (!e.promise) { refrescar(); return; }
    e.promise.then(function (r) {
      var items = r && r.detail && r.detail.items;
      if (items) {
        var total = (r.cart && typeof r.cart.totalQuantity === 'number') ? r.cart.totalQuantity : items.reduce(function (n, i) { return n + (i.quantity || 0); }, 0);
        ultimo = { item_count: total, items: items, discount_codes: (ultimo && ultimo.discount_codes) || [] };
        pintar(ultimo);
        requestAnimationFrame(function () { pintar(ultimo); });
        // Y luego la verdad completa de /cart.js (opciones, códigos, total).
        refrescar();
      } else refrescar();
    }).catch(function () {});
  });
  document.addEventListener('shopify:cart:discount-update', function (e) {
    if (e.promise) e.promise.then(function () { refrescar(); }).catch(function () {});
  });
  var cajon = document.getElementById('cart-drawer');
  if (cajon) {
    var dlg = cajon.querySelector('dialog') || cajon;
    new MutationObserver(function () {
      var abierto = cajon.hasAttribute('open') || (dlg && dlg.open);
      if (!abierto) return;
      var esc = document.querySelector('[data-mrh-empu="escalera"]');
      var faltaEsc = escNecesaria && (!esc || !esc.isConnected);
      var faltaCod = cfg.mostrarCodigos === '1' && datos.codigos.length && !document.querySelector('[data-mrh-empu="codigos"]');
      var faltaPago = cfg.textoPago && cajon.querySelector('.cart__ctas') && !cajon.querySelector('[data-mrh-empu="pago"]');
      if (faltaEsc || faltaCod || faltaPago) refrescar();
    }).observe(cajon, { attributes: true, childList: true, subtree: true });
  }
  var enPag = cfg.enPagina === '1' ? document.querySelector('main cart-items-component, #MainContent cart-items-component') : null;
  if (enPag && !enPag.closest('#cart-drawer')) {
    var repintando = false;
    new MutationObserver(function () {
      if (repintando) return;
      var esc = document.querySelector('[data-mrh-empu="escalera"]');
      var faltaCod = cfg.mostrarCodigos === '1' && datos.codigos.length && !document.querySelector('[data-mrh-empu="codigos"]');
      var faltaSug = ultimo && candidatos(ultimo).length && !document.querySelector('[data-mrh-empu="sugerencias"]');
      var faltaEsc = escNecesaria && (!esc || !esc.isConnected);
      if (faltaEsc || faltaCod || faltaSug) { repintando = true; refrescar(); setTimeout(function () { repintando = false; }, 50); }
    }).observe(enPag, { childList: true, subtree: true });
  }
  if (cfg.enPagina === '1' && document.querySelector('cart-items-component') && !document.querySelector('#cart-drawer cart-items-component:only-child')) refrescar();
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mrh_ficha"] && !Shopify.designMode) return;
  try {
    
(function () {
  // ---- el medidor: terpenos tocables y barras que se llenan al verse ----
  document.querySelectorAll('[data-mrh-medidor]').forEach(function (med) {
    var chips = med.querySelectorAll('[data-mrh-terpeno]');
    var aroma = med.querySelector('[data-mrh-aroma]');
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        chips.forEach(function (o) { o.setAttribute('aria-pressed', o === c ? 'true' : 'false'); });
        if (aroma) aroma.textContent = c.dataset.aroma || '';
      });
    });
    var quieto = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (quieto || !('IntersectionObserver' in window)) return;
    med.setAttribute('data-anima', '');
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.disconnect();
        // Un cuadro después, para que el navegador pinte primero el estado vacío.
        requestAnimationFrame(function () { requestAnimationFrame(function () { med.setAttribute('data-visto', ''); }); });
      });
    }, { threshold: 0.35 });
    io.observe(med);
  });

  document.querySelectorAll('[data-mrh-ficha]').forEach(function (raiz) {
    var form = raiz.querySelector('[data-mrh-ficha-form]');
    if (!form) return;
    var radios = form.querySelectorAll('[data-mrh-variante]');
    var precio = raiz.querySelector('[data-mrh-precio]');
    var pista = raiz.querySelector('[data-mrh-pista]');
    var puntos = raiz.querySelectorAll('[data-mrh-puntos] i');
    var boton = form.querySelector('[data-mrh-boton]');
    var cant = form.querySelector('[data-mrh-cant]');
    var hecho = raiz.querySelector('[data-mrh-hecho]');
    var error = raiz.querySelector('[data-mrh-error]');
    var tramos = raiz.querySelectorAll('[data-mrh-escalera] li');
    var bateria = raiz.querySelector('[data-mrh-bateria]');
    var batHecho = raiz.querySelector('[data-mrh-bat-hecho]');
    var minCaja = parseInt(raiz.dataset.minCaja, 10) || 3;
    var minEmb = parseInt(raiz.dataset.minEmbarque, 10) || 5;

    function elegida() {
      return form.querySelector('[data-mrh-variante]:checked') || form.querySelector('input[name="id"]');
    }
    function n() { return Math.max(1, parseInt(cant.value, 10) || 1); }

    // ---- la galería: puntos que siguen al deslizamiento ----
    var fotos = pista ? Array.prototype.slice.call(pista.children) : [];
    function pintarPuntos() {
      if (!pista || !puntos.length) return;
      var i = Math.round(pista.scrollLeft / Math.max(1, pista.clientWidth));
      puntos.forEach(function (pt, k) { if (k === i) pt.setAttribute('data-activo', ''); else pt.removeAttribute('data-activo'); });
    }
    // Salto instantáneo, no suave: el scroll programado con `smooth` no
    // se mueve en algunos navegadores incrustados y en modo de movimiento
    // reducido; el snap de la pista ya hace el trabajo visual.
    function irAFoto(mediaId) {
      if (!pista || !mediaId) return;
      var li = pista.querySelector('[data-media-id="' + mediaId + '"]');
      if (!li) return;
      pista.scrollLeft = li.offsetLeft;
      pintarPuntos();
    }
    if (pista) {
      pista.addEventListener('scroll', pintarPuntos, { passive: true });
      if (raiz.dataset.medioInicial) irAFoto(raiz.dataset.medioInicial);
    }

    // ---- la variante: precio, botón, foto y URL ----
    function pintarVariante() {
      var r = elegida(); if (!r) return;
      if (precio && r.dataset.precio) precio.textContent = r.dataset.precio;
      var ok = r.dataset.disponible !== '0';
      boton.disabled = !ok;
      boton.textContent = ok ? raiz.dataset.textoBoton : raiz.dataset.textoAgotado;
      if (r.dataset.medio) irAFoto(r.dataset.medio);
      // La tira de la batería solo con el dispositivo que la pide (MrPen).
      if (bateria) bateria.hidden = (r.dataset.titulo || '').indexOf(bateria.dataset.con || 'MrPen') === -1;
      if (r.type === 'radio' && window.history && window.history.replaceState) {
        try { var u = new URL(window.location.href); u.searchParams.set('variant', r.value); window.history.replaceState(null, '', u); } catch (e) {}
      }
      hecho.hidden = true; error.hidden = true;
    }
    function pintarCantidad() {
      var t = n(); cant.value = t;
      var tramo = t >= minEmb ? 2 : (t >= minCaja ? 1 : 0);
      tramos.forEach(function (li, i) {
        if (i === tramo) li.setAttribute('aria-current', 'true'); else li.removeAttribute('aria-current');
      });
      hecho.hidden = true;
    }

    radios.forEach(function (r) { r.addEventListener('change', pintarVariante); });
    form.querySelector('[data-mrh-menos]').addEventListener('click', function () { cant.value = n() - 1; pintarCantidad(); });
    form.querySelector('[data-mrh-mas]').addEventListener('click', function () { cant.value = n() + 1; pintarCantidad(); });
    cant.addEventListener('change', pintarCantidad);

    // ---- el carrito de Horizon 3.5 ----
    // El cajón, la burbuja y las fichas escuchan `shopify:cart:lines-update`
    // con una promesa que resuelve el carrito. Mismo mecanismo que EMBARQUE.
    var eventos = null;
    try { import('@shopify/events').then(function (m) { eventos = m; }, function () {}); } catch (e) {}
    function seccionesCarrito() {
      var ids = [];
      document.querySelectorAll('cart-items-component').forEach(function (c) { if (c.dataset.sectionId) ids.push(c.dataset.sectionId); });
      return ids.join(',');
    }
    function avisar(items, promesa) {
      var datos = {
        action: 'add', context: 'product', promise: promesa,
        lines: items.map(function (i) { return { merchandiseId: i.id, quantity: i.quantity }; })
      };
      var ev;
      if (eventos && eventos.CartLinesUpdateEvent) ev = new eventos.CartLinesUpdateEvent(datos);
      else { ev = new Event('shopify:cart:lines-update', { bubbles: true, cancelable: true }); Object.assign(ev, datos); }
      raiz.dispatchEvent(ev);
    }
    function carritoPara(c) {
      if (eventos && eventos.CartLinesUpdateEvent) return eventos.CartLinesUpdateEvent.createCartFromAjaxResponse(c);
      return { totalQuantity: c.item_count };
    }
    function leerCarrito() {
      return fetch(raiz.dataset.urlCarrito + '.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
    }
    function resolver(listo, resp, agregadas, fallo) {
      leerCarrito().then(function (c) {
        listo.res({ cart: carritoPara(c), detail: {
          items: c.items, source: 'mrh-ficha', sourceId: 'mrh-ficha',
          itemCount: agregadas, sections: resp && resp.sections, didError: fallo } });
      }, listo.rej);
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var r = elegida();
      if (!r || boton.disabled || boton.dataset.mrhOcupado) return;
      var t = n();
      var items = [{ id: parseInt(r.value, 10), quantity: t }];
      boton.dataset.mrhOcupado = '1'; boton.disabled = true;
      var listo = {};
      var promesa = new Promise(function (res, rej) { listo.res = res; listo.rej = rej; });
      avisar(items, promesa);
      var cuerpo = { items: items }, secs = seccionesCarrito();
      if (secs) cuerpo.sections = secs;
      fetch(raiz.dataset.urlAdd + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(cuerpo)
      }).then(function (res) {
        if (!res.ok) return res.json().then(function (j) { throw new Error(j.description || j.message || res.status); });
        return res.json();
      }).then(function (resp) {
        var texto = (t === 1 && raiz.dataset.textoHechoUno) ? raiz.dataset.textoHechoUno : raiz.dataset.textoHecho;
        hecho.innerHTML = texto.replace('[n]', t) +
          (raiz.dataset.urlCarrito ? ' <a href="' + raiz.dataset.urlCarrito + '">' + raiz.dataset.textoPagar + '</a>' : '');
        hecho.hidden = false;
        resolver(listo, resp, t, false);
      }).catch(function (err) {
        error.textContent = err.message || 'No se pudo agregar. Intenta otra vez.';
        error.hidden = false;
        resolver(listo, null, 0, true);
      }).then(function () { delete boton.dataset.mrhOcupado; boton.disabled = false; });
    });

    // ---- ¿ya tienes tu batería?: cada + agrega una sin salir de la ficha ----
    raiz.querySelectorAll('[data-mrh-bat-form]').forEach(function (f) {
      var b = f.querySelector('button');
      f.addEventListener('submit', function (e) {
        e.preventDefault();
        if (b.disabled) return;
        b.disabled = true;
        var items = [{ id: parseInt(f.querySelector('[name="id"]').value, 10), quantity: 1 }];
        var listo = {};
        var promesa = new Promise(function (res, rej) { listo.res = res; listo.rej = rej; });
        avisar(items, promesa);
        var cuerpo = { items: items }, secs = seccionesCarrito();
        if (secs) cuerpo.sections = secs;
        fetch(raiz.dataset.urlAdd + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(cuerpo)
        }).then(function (res) {
          if (!res.ok) return res.json().then(function (j) { var x = new Error(j.description || j.message || res.status); x.mrh = true; throw x; });
          return res.json();
        }).then(function (resp) {
          b.textContent = '✓'; b.setAttribute('data-hecho', '');
          setTimeout(function () { b.textContent = '+'; b.removeAttribute('data-hecho'); }, 1600);
          if (batHecho) {
            batHecho.innerHTML = '';
            batHecho.appendChild(document.createTextNode((raiz.dataset.textoBatHecho || '').replace('[color]', (f.dataset.color || '').toLowerCase()) + ' '));
            if (raiz.dataset.urlCarrito) {
              var a = document.createElement('a'); a.href = raiz.dataset.urlCarrito; a.textContent = raiz.dataset.textoPagar; batHecho.appendChild(a);
            }
            batHecho.hidden = false;
          }
          resolver(listo, resp, 1, false);
        }).catch(function (err) {
          if (batHecho) { batHecho.textContent = (err && err.mrh && err.message) || 'No se pudo agregar. Intenta otra vez.'; batHecho.hidden = false; }
          resolver(listo, null, 0, true);
        }).then(function () { b.disabled = false; });
      });
    });

    pintarCantidad();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mrh_hero_video"] && !Shopify.designMode) return;
  try {
    
(function () {
  var quieto = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function mmss(seg) {
    if (!isFinite(seg) || seg <= 0) return '';
    seg = Math.round(seg);
    return ('0' + Math.floor(seg / 60)).slice(-2) + ':' + ('0' + (seg % 60)).slice(-2);
  }
  document.querySelectorAll('[data-mrh-hero-video]').forEach(function (raiz) {
    var clips = Array.prototype.slice.call(raiz.querySelectorAll('[data-mrh-clip]'));
    var videos = clips.map(function (c) { return c.querySelector('video'); });
    if (!videos.some(Boolean)) return;
    var marco = raiz.querySelector('[data-mrh-marco]');
    var play = raiz.querySelector('[data-mrh-play]');
    var sonido = raiz.querySelector('[data-mrh-sonido]');
    var duracion = raiz.querySelector('[data-mrh-duracion]');
    var puntos = raiz.querySelector('[data-mrh-puntos]');
    var autoplay = raiz.getAttribute('data-autoplay') === '1' && !quieto;
    var avanzar = raiz.getAttribute('data-avanzar') === '1';
    var conSonido = false, actual = 0, visible = true;

    videos.forEach(function (v) {
      if (!v) return;
      v.controls = false;
      v.removeAttribute('autoplay');
      v.loop = false;
      // WebKit solo deja arrancar solo si `muted` es atributo, no solo propiedad.
      v.defaultMuted = true;
      v.muted = true;
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      v.setAttribute('webkit-playsinline', '');
    });
    marco.hidden = false;
    if (sonido) sonido.hidden = false;
    if (puntos) puntos.hidden = false;

    function pintarEstado() {
      var v = videos[actual];
      var parado = !v || v.paused;
      play.hidden = !parado;
      marco.setAttribute('aria-label', parado ? raiz.getAttribute('data-aria-reproducir') : raiz.getAttribute('data-aria-pausar'));
      if (puntos) puntos.querySelectorAll('[data-mrh-punto]').forEach(function (p, i) {
        if (i === actual) p.setAttribute('aria-current', 'true'); else p.removeAttribute('aria-current');
      });
      if (duracion) {
        var fija = clips[actual].getAttribute('data-duracion');
        duracion.textContent = fija || (v ? mmss(v.duration) : '');
      }
    }
    // Si el navegador rechaza arrancar solo (ahorro de batería, datos,
    // política del navegador), se queda el glifo y el primer gesto en la
    // página vuelve a intentarlo: un toque o un scroll ya cuentan.
    var esperandoGesto = false;
    function alPrimerGesto() {
      if (esperandoGesto) return;
      esperandoGesto = true;
      var una = function () {
        document.removeEventListener('touchstart', una);
        document.removeEventListener('pointerdown', una);
        document.removeEventListener('keydown', una);
        esperandoGesto = false;
        var v = videos[actual];
        if (v && v.paused && visible && !conSonido) reproducir();
      };
      document.addEventListener('touchstart', una, { passive: true });
      document.addEventListener('pointerdown', una, { passive: true });
      document.addEventListener('keydown', una);
    }
    function reproducir() {
      var v = videos[actual];
      if (!v) return;
      v.muted = !conSonido;
      if (v.muted) v.setAttribute('muted', ''); else v.removeAttribute('muted');
      var p = v.play();
      if (p && p.catch) p.catch(function () { pintarEstado(); if (autoplay) alPrimerGesto(); });
      pintarEstado();
    }
    function pausar() {
      var v = videos[actual];
      if (v && !v.paused) v.pause();
      pintarEstado();
    }
    function ir(n, arrancar) {
      if (n === actual && arrancar) { reproducir(); return; }
      var viejo = videos[actual];
      if (viejo && !viejo.paused) viejo.pause();
      if (viejo) { try { viejo.currentTime = 0; } catch (e) {} }
      actual = (n + clips.length) % clips.length;
      clips.forEach(function (c, i) { c.hidden = i !== actual; });
      var v = videos[actual];
      if (v && v.preload === 'none') { v.preload = 'metadata'; v.load(); }
      if (arrancar && v) reproducir(); else pintarEstado();
    }

    marco.addEventListener('click', function () {
      var v = videos[actual];
      if (!v) return;
      if (v.paused) reproducir(); else pausar();
    });
    if (sonido) sonido.addEventListener('click', function () {
      conSonido = !conSonido;
      var v = videos[actual];
      if (v) { v.muted = !conSonido; if (conSonido && v.paused) reproducir(); }
      sonido.setAttribute('aria-pressed', conSonido ? 'true' : 'false');
      sonido.setAttribute('aria-label', conSonido ? raiz.getAttribute('data-aria-sonido-off') : raiz.getAttribute('data-aria-sonido-on'));
    });
    if (puntos) puntos.addEventListener('click', function (e) {
      var p = e.target.closest('[data-mrh-punto]');
      if (!p) return;
      ir(parseInt(p.getAttribute('data-mrh-punto'), 10), true);
    });
    videos.forEach(function (v, i) {
      if (!v) return;
      v.addEventListener('loadedmetadata', function () { if (i === actual) pintarEstado(); });
      // Algunos móviles rechazan play() antes de tener datos: al poder, se reintenta una vez.
      v.addEventListener('canplay', function () { if (i === actual && autoplay && v.paused && visible && !conSonido && !v.dataset.mrhReintento) { v.dataset.mrhReintento = '1'; reproducir(); } });
      v.addEventListener('play', pintarEstado);
      v.addEventListener('pause', pintarEstado);
      v.addEventListener('ended', function () {
        if (i !== actual) return;
        if (clips.length > 1 && avanzar) ir(actual + 1, visible);
        else { try { v.currentTime = 0; } catch (e) {} if (visible) reproducir(); }
      });
    });

    // Fuera de pantalla se calla; al volver, sigue si arrancaba solo.
    // Umbral bajo (un 15 % basta) para que un encabezado alto o un
    // teléfono chico no lo den por fuera de pantalla al cargar.
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          visible = e.isIntersecting;
          var v = videos[actual];
          if (!v) return;
          if (!visible && !v.paused) v.pause();
          else if (visible && v.paused && autoplay && !conSonido) reproducir();
        });
      }, { threshold: 0.15 }).observe(raiz);
    }

    if (autoplay) reproducir(); else pintarEstado();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mrh_menu"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-mrh-enc]').forEach(function (raiz) {
    // ---- fijo: marcar el contenedor de la sección para el sticky ----
    if (raiz.classList.contains('mrh-enc--fijo')) {
      var cont = raiz.closest('.shopify-section');
      if (cont) cont.setAttribute('data-mrh-fijo', '');
    }

    // ---- el menú: <dialog> nativo ----
    var dlg = raiz.querySelector('[data-mrh-menu]');
    var abrirMenu = raiz.querySelector('[data-mrh-menu-abrir]');
    var cerrarMenu = raiz.querySelector('[data-mrh-menu-cerrar]');
    if (dlg && abrirMenu) {
      if (typeof dlg.showModal === 'function') {
        abrirMenu.addEventListener('click', function () {
          if (dlg.open) { dlg.close(); return; }
          dlg.showModal(); abrirMenu.setAttribute('aria-expanded', 'true');
        });
        dlg.addEventListener('close', function () { abrirMenu.setAttribute('aria-expanded', 'false'); abrirMenu.focus(); });
        if (cerrarMenu) cerrarMenu.addEventListener('click', function () { dlg.close(); });
        dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
      } else {
        // Sin <dialog>: el botón lleva a la fila de enlaces.
        abrirMenu.addEventListener('click', function () { var fila = raiz.querySelector('.mrh-enc__fila'); if (fila) fila.focus(); });
      }
    }

    // ---- el buscador: panel + sugerencias ----
    var panel = raiz.querySelector('[data-mrh-buscar]');
    var abrirBuscar = raiz.querySelector('[data-mrh-buscar-abrir]');
    var cerrarBuscar = raiz.querySelector('[data-mrh-buscar-cerrar]');
    var campo = raiz.querySelector('[data-mrh-q]');
    var caja = raiz.querySelector('[data-mrh-sugerencias]');
    function mostrarBuscar(si) {
      if (!panel) return;
      panel.hidden = !si;
      if (abrirBuscar) abrirBuscar.setAttribute('aria-expanded', si ? 'true' : 'false');
      if (si && campo) campo.focus();
      if (!si && caja) caja.innerHTML = '';
    }
    if (abrirBuscar) abrirBuscar.addEventListener('click', function () { mostrarBuscar(panel.hidden); });
    if (cerrarBuscar) cerrarBuscar.addEventListener('click', function () { mostrarBuscar(false); if (abrirBuscar) abrirBuscar.focus(); });
    if (panel) panel.addEventListener('keydown', function (e) { if (e.key === 'Escape') { mostrarBuscar(false); if (abrirBuscar) abrirBuscar.focus(); } });

    var escapar = function (s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
    var controlador = null, espera = null;
    function sugerir(q) {
      if (!caja) return;
      if (controlador) controlador.abort();
      if (q.length < 2) { caja.innerHTML = ''; return; }
      controlador = new AbortController();
      var base = raiz.dataset.urlSugerencias || '/search/suggest';
      var url = base + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title';
      fetch(url, { signal: controlador.signal, headers: { 'Accept': 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (j) {
          var productos = (j.resources && j.resources.results && j.resources.results.products) || [];
          var html = productos.map(function (p) {
            var img = p.featured_image && p.featured_image.url ? '<img src="' + escapar(p.featured_image.url) + '" alt="" loading="lazy">' : '<span></span>';
            return '<a class="mrh-enc__sug" href="' + escapar(p.url) + '">' + img +
              '<span class="mrh-enc__sug-nombre">' + escapar(p.title) + '</span>' +
              '<span class="mrh-enc__sug-precio">' + escapar(p.price || '') + '</span></a>';
          }).join('');
          if (productos.length) {
            html += '<a class="mrh-enc__sug-todo" href="' + escapar(raiz.dataset.urlBusqueda || '/search') + '?q=' + encodeURIComponent(q) + '&type=product">' + escapar(raiz.dataset.textoVerTodo || 'Ver todo') + '</a>';
          } else {
            html = '<p class="mrh-enc__sug-nada">' + escapar(raiz.dataset.textoSinResultados || 'Nada por aquí.') + '</p>';
          }
          caja.innerHTML = html;
        })
        .catch(function (err) { if (err.name !== 'AbortError') caja.innerHTML = ''; });
    }
    if (campo) campo.addEventListener('input', function () { clearTimeout(espera); var q = campo.value.trim(); espera = setTimeout(function () { sugerir(q); }, 220); });

    // ---- el carrito: burbuja y cajón de Horizon ----
    var burbuja = raiz.querySelector('[data-mrh-burbuja]');
    var carrito = raiz.querySelector('[data-mrh-carrito]');
    function pintarBurbuja(n) {
      if (!burbuja) return;
      burbuja.textContent = n;
      if (n > 0) burbuja.removeAttribute('data-vacia'); else burbuja.setAttribute('data-vacia', '');
      if (carrito) carrito.setAttribute('aria-label', (carrito.getAttribute('aria-label') || 'Carrito').replace(/,\s*\d+$/, '') + ', ' + n);
    }
    document.addEventListener('shopify:cart:lines-update', function (e) {
      if (!e.promise) return;
      e.promise.then(function (r) {
        var n = (r && r.cart && typeof r.cart.totalQuantity === 'number') ? r.cart.totalQuantity : null;
        if (n === null) return;
        pintarBurbuja(n);
      }).catch(function () {});
    });
    // Al volver con el botón atrás, la burbuja se relee del servidor.
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      fetch((raiz.dataset.urlCarrito || '/cart') + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); }).then(function (c) { pintarBurbuja(c.item_count); }).catch(function () {});
    });
    if (carrito) carrito.addEventListener('click', function (e) {
      var cajon = document.getElementById('cart-drawer');
      if (cajon && typeof cajon.open === 'function') { e.preventDefault(); cajon.open(); }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mrh_sillega"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-mrh-sillega]').forEach(function (raiz) {
    var tarjetas = raiz.querySelectorAll('.mrh-sl__tarjeta');
    var videos = [];
    tarjetas.forEach(function (t) {
      var video = t.querySelector('video');
      var marco = t.querySelector('[data-mrh-marco]');
      if (!video || !marco) return;
      // Con JS mandan el marco y el glifo; sin JS, los controles nativos.
      video.controls = false;
      video.setAttribute('playsinline', '');
      marco.hidden = false;
      videos.push(video);

      // Parar deja la tarjeta y su etiqueta accesible como al inicio, sea
      // cual sea el motivo: toque, fin del video, otro video o salir de pantalla.
      function parar(v) {
        v.pause();
        var tj = v.closest('.mrh-sl__tarjeta'), m = tj.querySelector('[data-mrh-marco]');
        tj.removeAttribute('data-mrh-reproduciendo');
        if (m) m.setAttribute('aria-label', m.getAttribute('aria-label').replace(/^Pausar/, 'Reproducir'));
      }
      function tocar() {
        if (video.paused) {
          videos.forEach(function (o) { if (o !== video && !o.paused) parar(o); });
          var p = video.play();
          t.setAttribute('data-mrh-reproduciendo', '');
          marco.setAttribute('aria-label', marco.getAttribute('aria-label').replace(/^Reproducir/, 'Pausar'));
          if (p && p.catch) p.catch(function () { parar(video); });
        } else {
          parar(video);
        }
      }
      marco.addEventListener('click', tocar);
      video.addEventListener('ended', function () { parar(video); });
    });
    // Si la sección sale de pantalla, se calla.
    if ('IntersectionObserver' in window && videos.length) {
      new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (!e.isIntersecting) videos.forEach(function (v) { if (!v.paused) { v.pause(); var tj = v.closest('.mrh-sl__tarjeta'), m = tj.querySelector('[data-mrh-marco]'); tj.removeAttribute('data-mrh-reproduciendo'); if (m) m.setAttribute('aria-label', m.getAttribute('aria-label').replace(/^Pausar/, 'Reproducir')); } });
        });
      }, { threshold: 0 }).observe(raiz);
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
